import { render, staticRenderFns } from "./OrderHistoryContainer.vue?vue&type=template&id=7b0aa334&"
import script from "./OrderHistoryContainer.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports